/* @flow */

import React from 'react';
import { observer } from 'mobx-react';
import ReactTooltip from 'react-tooltip';

@observer
export default class Tooltip extends React.Component {
    props: {
        children?: HTMLElement,
        id: string,
    };

    render() {
        return (
            <ReactTooltip { ...this.props } effect="solid">
                {this.props.children}
            </ReactTooltip>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Tooltip/index.js